export default __webpack_public_path__ + "images/credit-card.8cbd38ad.svg";